import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'dueDateFull', standalone: true, pure: true})
export class DueDateFullPipe implements PipeTransform {
  transform(date: Date | string | null | undefined): string {
    if (!date) return '';

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
